export enum FilterSectionV2Id {
  TAGS = "tags",
  FEATURES = "features",
  DEFINITION_SIZE = "definitionSize",
  LANGUAGE = "language",
  CHAT_SIZE = "chatSize",
}

export const FILTER_SECTION_V2_ORDER = [
  FilterSectionV2Id.TAGS,
  FilterSectionV2Id.FEATURES,
  FilterSectionV2Id.DEFINITION_SIZE,
  FilterSectionV2Id.LANGUAGE,
  FilterSectionV2Id.CHAT_SIZE,
] as const;
